import { createFileRoute, notFound } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { PvReception, Sav, type Task } from "@relais/contracts";
import { useOffline } from "../lib/offline-context.js";
import { PvStepPage } from "../features/pv-reception/PvStepPage.js";
import { SavStepPage } from "../features/sav/SavStepPage.js";

export const Route = createFileRoute("/pv/$taskId/$step")({
  component: PvStepRoute,
});

/**
 * Le type de la tâche décide du wizard ; il est relu depuis Dexie (le layout
 * parent l'a déjà, mais ne l'expose pas par contexte de route). Une clé
 * d'étape qui n'appartient pas au wizard du type → 404, comme avant.
 */
function PvStepRoute() {
  const { taskId, step } = Route.useParams();
  const { service } = useOffline();
  const [type, setType] = useState<Task["type"] | null>(null);

  useEffect(() => {
    if (!service) return;
    let cancelled = false;
    service.getTask(taskId).then((t) => {
      if (!cancelled && t) setType(t.type);
    });
    return () => {
      cancelled = true;
    };
  }, [service, taskId]);

  if (type === null) {
    return <p className="text-sm text-muted-foreground">…</p>;
  }
  if (type === "sav") {
    const found = Sav.findSavStep(step as Sav.SavStepKey);
    if (!found) throw notFound();
    return <SavStepPage step={found.key} />;
  }
  const found = PvReception.findPvReceptionStep(step as PvReception.PvReceptionStepKey);
  if (!found) throw notFound();
  return <PvStepPage step={found.key} />;
}
